// Active-organization state in localStorage (mirrors auth.js — no context/provider).
// The api.js interceptor sends `active_org_id` as the X-Org-Id header.
//
// Permissions come from the server with each org (see rbac.permissions_for_role)
// and are what the UI gates on. Render on `can(...)`, never on the role name, so
// a role added to the registry needs no change here.

export function getActiveOrg() {
  return localStorage.getItem('active_org_id') || '';
}
export function getActiveOrgName() {
  return localStorage.getItem('active_org_name') || '';
}
export function getActiveOrgRole() {
  return localStorage.getItem('active_org_role') || '';
}

export function getActiveOrgPermissions() {
  try {
    return JSON.parse(localStorage.getItem('active_org_permissions') || '[]');
  } catch {
    return [];
  }
}

export function can(permission) {
  return getActiveOrgPermissions().includes(permission);
}

// Opening the org console at all — every management page sits behind one of these.
export function isOrgManager() {
  return can(PERMISSIONS.TIERS_MANAGE) || can(PERMISSIONS.USERS_MANAGE);
}

export const PERMISSIONS = {
  ORG_UPDATE: 'org.update',
  ORG_DELETE: 'org.delete',
  ORG_TRANSFER: 'org.transfer',
  MEMBERS_INVITE: 'members.invite',
  MEMBERS_APPROVE: 'members.approve',
  MEMBERS_UPDATE_ROLE: 'members.update_role',
  MEMBERS_REMOVE: 'members.remove',
  TIERS_MANAGE: 'tiers.manage',
  TEAMS_MANAGE: 'teams.manage',
  USERS_MANAGE: 'users.manage',
  GUARDRAILS_MANAGE: 'guardrails.manage',
  PROMPTS_MANAGE: 'prompts.manage',
  SETTINGS_MANAGE: 'settings.manage',
  USAGE_READ: 'usage.read',
};

export function setActiveOrg(orgId, orgName, role, permissions) {
  if (orgId) localStorage.setItem('active_org_id', orgId);
  if (orgName != null) localStorage.setItem('active_org_name', orgName);
  if (role != null) localStorage.setItem('active_org_role', role);
  if (permissions != null) localStorage.setItem('active_org_permissions', JSON.stringify(permissions));
}

export function clearActiveOrg() {
  localStorage.removeItem('active_org_id');
  localStorage.removeItem('active_org_name');
  localStorage.removeItem('active_org_role');
  localStorage.removeItem('active_org_permissions');
}
